<template>
    <div  v-html="content">

    </div>
</template>
<script>
import {
   API_GetNewsListddh
} from "@/fetch/api"
export default {
    data () {
        return {
            link:'',
            content:'',
        }
    },

    created () {
        this.getNewsList(4130)
    },

    mounted () {

    },
    methods: {
        getLink(){
            this.$router.push(this.link)
        },
        getNewsList (nodeId) {
            API_GetNewsListddh({
                pageNo: 0,
                pageSize: 11,
                nodeId: nodeId,
            })
                .then(res => {
                    let { data } = res.data
                    this.content = data[0].content
                })
                .catch(err => {
                    console.log(err)
                })
        },
    }
}
</script>
<style scoped>

</style>